import React, { useEffect } from 'react';
import './rulesModal.css';

/**
 * Themed rules dialog: button background + button text color, red close.
 * Used by Cheers, Badges, Men's Day, Boss Counts, and Freedom.
 */
export default function RulesModal({
  open,
  onClose,
  rules = [],
  btnBg = '#088e01',
  btnText = '#ffffff',
  title = 'Rules',
  titleId = 'game-rules-title',
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const list = Array.isArray(rules) ? rules.filter((r) => String(r || '').trim()) : [];

  return (
    <div className="game-rules-overlay" role="presentation" onClick={onClose}>
      <div
        className="game-rules-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        style={{ backgroundColor: btnBg, color: btnText }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="game-rules-modal-header">
          <h2 id={titleId} style={{ color: btnText }}>
            {title}
          </h2>
          <button
            type="button"
            className="game-rules-close"
            aria-label="Close rules"
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        {list.length === 0 ? (
          <p className="game-rules-empty" style={{ color: btnText }}>
            No rules have been set for this game yet.
          </p>
        ) : (
          <ul className="game-rules-list" style={{ color: btnText }}>
            {list.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
